import { createIcon } from './factory'
import Icon from './package.svg?react'

export const Package = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
